import BeelditSwitchInput from "@beeldit/core/components/BeelditSwitchInput";
import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import TreatmentSessionTypeSelector from "@main/treatment-session-types/components/TreatmentSessionTypeSelector";
import TreatmentSelector from "@main/treatments/components/TreatmentSelector";
import { Gear, Pencil, Plus, Trash } from "@phosphor-icons/react";
import { Calendar } from "@phosphor-icons/react/dist/ssr";
import { t } from "i18next";
import { min } from "lodash";
import PriceInput from "./components/PriceInput";

const config = {
  modelName: "customer-treatment",
  modelPluralName: "customers-treatments",
  endpoint: "customers-treatments",
  indexQueryParams: {
    relations: ['treatment', 'treatment_session_type'],
  },
  tableConfig: {
    index: null,
    actions: [
      {
        name: TableAction.CREATE,
        label: "create",
        showLabel: true,
        allowed: true,
        show: true,
        action: null,
        icon: <Plus size={20} />,
      },
    ],
    rowActions: [
      {
        name: RowAction.EDIT,
        label: "edit",
        icon: <Pencil size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("edit", element);
        },
      },
      {
        name: 'edit-schedule',
        label: "edit-schedule",
        icon: <Calendar size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("edit-schedule", element);
        },
      },
      
      {
        name: RowAction.DELETE,
        label: "delete",
        icon: <Trash size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("delete", element);
        },
      },
    ],
    rowConfiguration: {
      class: (element: any) => {
        return null;
      },
    },
    columns: [
      {
        name: "id",
        label: "#",
        key: "id",
        type: "number",
        show: true,
        allowOrder: true,
      },
      {
        name: "treatment",
        label: "treatment",
        key: "treatment.name",
        type: "string",
        show: true,
        allowOrder: true,
      },
      {
        name: "treatment_session_type",
        label: "treatment_session_type",
        key: "treatment_session_type.name",
        type: "string",
        show: true,
        allowOrder: true,
      },
      {
        name: "treatment_description",
        label: "treatment_description",
        key: "treatment_session_type.description",
        type: "string",
        show: true,
        allowOrder: true,
      },
      
    ],
    pagination: {
      enabled: true,
      back: true,
    },
  },
  filterConfig: {
    type: "object",
    properties: {
      search: {
        type: "string",
      },
    },
  },
  filterUIConfig: {
    uiScheme: {
      className: "filters-container",
      search: {
        "ui:options": {
          label: false, // Oculta el título del campo
          placeholder: "Buscar...",
        },
      },
    },
    widgets: {},
  },
  formSchema: {
    type: "object",
    properties: {      
      // treatment_id
      treatment_id: {
        type: "number",
        title: t("treatment_id"),
      },
      
        treatment_session_type_id: {
        type: "number",
        title: t("treatment_session_type_id"),
        format: "date",        
      },
      // base_price
      base_price: {
        type: "number",
        title: t("base_price"),
        default: 0,
      },
     
      // discount
      discount: {
        type: "number",
        title: t("discount"),
        default: 0,
      },
      // monthly_price
      monthly_price: {
        type: "number",
        title: t("monthly_price"),
        default: 0,
      },
      // start_date
      start_date: {
        type: "string",
        title: t("start_date"),
        format: "date",
      },
      // end_date
      end_date: {
        type: "string",
        title: t("end_date"),
        format: "date",
      },
      // scholarship
      scholarship: {
        type: ["number", "null", "boolean"],
        title: t("scholarship"),
        default: 0,
      },      
    },
  },
  uiFormSchema: {
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },
      norender: true,
    },
    treatment_id: {
      "ui:widget": TreatmentSelector
    },
    treatment_session_type_id: {
      "ui:widget": TreatmentSessionTypeSelector
    },
    scholarship: {
      "ui:widget": BeelditSwitchInput,
    },
    monthly_price: {
      "ui:widget": PriceInput,
    },
    colsSchema: [
      {
        cols: "col-12",
        elements: [
          [
            {
              name: "treatment_id",
              cols: "col-6",
            },
            {
              name: "treatment_session_type_id",
              cols: "col-6",
            },            
            {
              name: "base_price",
              cols: "col-6",
            },
            
            {
              name: "discount",
              cols: "col-6",
            },
            {
              name: "monthly_price",
              cols: "col-6",
            },
            {
              name: "scholarship",
              cols: "col-6",
            },
            {
              name: "start_date",
              cols: "col-6",
            },
            {
              name: "end_date",
              cols: "col-6",
            },            
          ],
        ],
      },
    ],
  },
};
export default config;
